// `.cs` switch from base.html, kept visually identical.

export function Toggle({
  checked,
  onChange,
  label,
  disabled,
  ariaLabel,
}: {
  checked: boolean;
  onChange: (next: boolean) => void;
  label?: string;
  disabled?: boolean;
  ariaLabel?: string;
}) {
  return (
    <button
      type="button"
      className="cs"
      role="switch"
      aria-checked={checked}
      aria-label={ariaLabel || label}
      disabled={disabled}
      onClick={() => !disabled && onChange(!checked)}
    >
      <span className="cs-track">
        <span className="cs-thumb" />
      </span>
      <span className="cs-label">{checked ? "on" : "off"}</span>
    </button>
  );
}
